/* Shared product-search scope. Article/NEWS/BLOG search is intentionally independent. */
(() => {
  const filterName = 'filter.p.m.custom.is_outlet';
  const decode = (query) => {
    if (!query.startsWith('(title:"') || !/ AND -?tag:OUTLET$/.test(query)) return query;
    return [...query.matchAll(/\(title:"((?:\\.|[^"\\])*)" OR body:/g)]
      .map((match) => match[1].replace(/\\([\\"])/g, '$1')).join(' ');
  };
  // Only decode old theme-generated URLs. Never turn user words into search syntax.
  const query = (words) => decode(words).trim();
  // Legacy vendor URLs use the same server boolean filter, without changing the vendor query.
  const vendorUrl = (href) => {
    const result = new URL(href, window.location.origin);
    if (result.origin !== window.location.origin || !/\/collections\/vendors\/?$/.test(result.pathname)) return result;
    if (!result.searchParams.get('q')?.trim()) return result;
    const values = result.searchParams.getAll(filterName);
    if (values.length === 1 && ['0', '1'].includes(values[0])) return result;
    result.searchParams.set(filterName, '0');
    result.searchParams.delete('page');
    return result;
  };
  const segment = () => {
    const params = new URLSearchParams(window.location.search);
    if (/\/collections\/vendors\/?$/.test(window.location.pathname) && params.get(filterName) === '1') return 'outlet';
    if (/\/(?:search)\/?$/.test(window.location.pathname)) {
      if (params.has(filterName)) return ['1', 'true'].includes(params.get(filterName)) ? 'outlet' : 'regular';
      if (params.get('catalog') === 'outlet' || / AND tag:OUTLET$/.test(params.get('q') || '')) return 'outlet';
      return 'regular';
    }
    return document.documentElement.dataset.tlCatalog || 'regular';
  };
  const url = (href, selected = segment()) => {
    const result = new URL(href, window.location.origin);
    if (result.origin !== window.location.origin || !/\/search\/?$/.test(result.pathname)) return result;
    if (result.searchParams.get('view') || ['article', 'page'].includes(result.searchParams.get('type'))) return result;
    result.searchParams.set('q', query(result.searchParams.get('q') || '', selected));
    result.searchParams.set(filterName, selected === 'outlet' ? '1' : '0');
    result.searchParams.delete('catalog');
    result.searchParams.set('type', 'product');
    if (!result.searchParams.has('options[prefix]')) result.searchParams.set('options[prefix]', 'last');
    return result;
  };
  window.TlCatalogSearch = { query, decode, segment, url, vendorUrl, filterName };

  // Direct and legacy product search URLs enter the same server-side query path.
  const current = new URL(window.location.href);
  const normalized = /\/collections\/vendors\/?$/.test(current.pathname) ? vendorUrl(current) : url(current);
  if (current.searchParams.get('q')?.trim() && current.toString() !== normalized.toString()) {
    document.documentElement.classList.add(/\/collections\/vendors\/?$/.test(current.pathname) ? 'tl-vendor-redirect' : 'tl-catalog-redirect');
    window.location.replace(normalized.toString());
  } else {
    document.documentElement.classList.remove('tl-catalog-pending');
    document.documentElement.classList.remove('tl-vendor-pending');
  }
  document.querySelectorAll(`[data-tl-catalog-form] input[name="${filterName}"]`).forEach((input) => { input.value = segment() === 'outlet' ? '1' : '0'; });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches('[data-tl-catalog-form]') && !form.closest('[data-tl-product-search]')) return;
    if (!/\/search\/?$/.test(new URL(form.action, window.location.origin).pathname)) return;
    if (event.defaultPrevented) return;
    const input = form.querySelector('input[name="q"]');
    if (!input?.value.trim()) { event.preventDefault(); return; }
    event.preventDefault();
    const target = new URL(form.action, window.location.origin);
    const selected = segment();
    for (const [key, value] of new FormData(form)) target.searchParams.append(key, value);
    target.searchParams.delete('page');
    window.location.assign(url(target, selected).toString());
  });
})();
